<template>
  <div class="common-modal">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="modal-inner">
        <div class="custom-modal-header">
          <div class="close-btn">
            <div class="btn-close" @click="$emit('close')"></div>
          </div>
          <p class="header">Formular importieren</p>
        </div>
        <div class="content">
          <p class="confirm-text">
            Möchten Sie das bestehende Formular ersetzen oder mit dem Import
            zusammenführen?
          </p>
          <div class="action-row">
            <button class="buttons" type="button" @click="$emit('merge')">
              Zusammenführen
            </button>
            <button
              class="buttons buttons-primary"
              type="button"
              @click="$emit('replace')"
            >
              Ersetzen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportFormConfirmModal',
};
</script>

<style scoped>
.common-modal .modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1055;
}

.common-modal .modal {
  padding: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 10px;
  display: block;
}

.common-modal .modal .modal-inner {
  width: fit-content;
  height: fit-content;
  background: #fff;
  padding: 24px 32px 20px 32px;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  max-width: 560px;
}

.common-modal .custom-modal-header {
  box-sizing: border-box;
  display: block;
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}

.common-modal .modal .btn-close:focus {
  outline: none;
  box-shadow: none;
}

.common-modal .modal .btn-close {
  position: absolute;
  right: -25px;
  top: -14px;
  padding: 0;
}

.common-modal .header {
  font-size: 18px;
  width: 100%;
  font-weight: 400;
  font-family: 'AktivGroteskMedium';
  margin-bottom: 0;
  color: #000;
}

.common-modal .content {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  padding: 8px 0;
}

.common-modal .confirm-text {
  font-size: 14px;
  font-weight: 400;
  font-family: 'AktivGroteskMedium';
  color: #000;
  margin: 0;
}

.common-modal .action-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.common-modal .buttons {
  background: white;
  border: 1px solid #cdcdcd;
  color: #9090a2;
  border-radius: 7px;
  line-height: 30px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  padding: 3px 13px;
  font-weight: 500;
  font-size: 14px;
}

.common-modal .buttons-primary {
  background-color: #333343;
  color: #ffffff;
  border-color: #333343;
}

.common-modal .buttons-primary:hover {
  background-color: transparent;
  color: #333343;
  border: 1px solid #333343;
}
</style>
